import api from 'api';

export const MENU_ITEM_SALES_ASYNC_ACTION_START = 'MENU_ITEM_SALES_ASYNC_ACTION_START';
export const MENU_ITEM_SALES_ASYNC_ACTION_ERROR = 'MENU_ITEM_SALES_ASYNC_ACTION_ERROR';
export const MENU_ITEM_SALES_ASYNC_UPDATE_SUCCESS = 'MENU_ITEM_SALES_ASYNC_UPDATE_SUCCESS';
export const MENU_ITEM_SALES_UPDATE_ACTION_SUCCESS = 'MENU_ITEM_SALES_UPDATE_ACTION_SUCCESS';
export const MENU_ITEM_SALES_CATEGORY_UPDATE_ACTION_SUCCESS = 'MENU_ITEM_SALES_CATEGORY_UPDATE_ACTION_SUCCESS';
export const MENU_ITEM_SALES_RESET_STATE = 'MENU_ITEM_SALES_RESET_STATE';

function menuItemSalesAsyncActionStart() {
  return {
    type: MENU_ITEM_SALES_ASYNC_ACTION_START,
  };
}

function menuItemSalesAsyncActionError(error) {
  return {
    type: MENU_ITEM_SALES_ASYNC_ACTION_ERROR,
    error,
  };
}

function menuItemSalesAsyncUpdateSuccess(data) {
  return {
    type: MENU_ITEM_SALES_ASYNC_UPDATE_SUCCESS,
    data,
  };
}

function menuItemSalesCategoryAsyncUpdateSuccess(data, userCategoryId) {
  return {
    type: MENU_ITEM_SALES_CATEGORY_UPDATE_ACTION_SUCCESS,
    data,
    userCategoryId,
  };
}

export function updateMenuItemSales(data) {
  return {
    type: MENU_ITEM_SALES_UPDATE_ACTION_SUCCESS,
    data,
  };
}

export function resetMenuItemSalesState() {
  return {
    type: MENU_ITEM_SALES_RESET_STATE,
  };
}

export function getMenuItemSales(menuId, periodId) {
  return (dispatch, getState) => {
    
    const periodIdSuffix = periodId > 0 ? `&periodId=${periodId}` : '';
    dispatch(menuItemSalesAsyncActionStart());
    return api.request(
      `menuItemSale/list?menuId=${menuId}${periodIdSuffix}`,
      'get',
      null
    )
      .then((data) => {
        dispatch(menuItemSalesAsyncUpdateSuccess(data));
        return data;
      })
      .catch((err) => {
        dispatch(menuItemSalesAsyncActionError('Unable to get Menu Item Sales'));
        throw (err);
      });
  };
}

export function getMenuItemSalesByCategory(menuId, userCategoryId, periodId) {
  return (dispatch, getState) => {
    
    const periodIdSuffix = periodId > 0 ? `&periodId=${periodId}` : '';
    dispatch(menuItemSalesAsyncActionStart());
    return api.request(
      `menuItemSale/list?menuId=${menuId}&categoryId=${userCategoryId}${periodIdSuffix}`,
      'get',
      null
    )
    .then((data) => {
      dispatch(menuItemSalesCategoryAsyncUpdateSuccess(data, userCategoryId));
      return data;
    })
    .catch((err) => {
      dispatch(menuItemSalesAsyncActionError('Unable to get Menu Item Sales'));
      throw (err);
    });
  };
}
